// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + {"3321":"css/admin-app.6905","6978":"css/app.6905"}[chunkId] + ".css";
};